import { Cell, Grid, TabItem, Tabs } from 'bold-ui'
import CheckPermission from 'components/auth/CheckPermission'
import { useSession } from 'components/auth/useSession'
import { useFlags } from 'config/useFlagsContext'
import React, { useMemo, useState } from 'react'
import { TipoAtendimentoFooter } from 'view/atendimentos/model-atendimento'

import { PlanoTabsEnum } from '../model-planoTabs'
import { getPlanoTabsConfig } from '../util-planoTabs'

interface PlanoTabsProps {
  tipoAtendimentoProfissional: TipoAtendimentoFooter
  isObservacaoAndAuxiliar?: boolean
  isFolhaRosto?: boolean
  isRetificacao?: boolean
  children: (currentTab: PlanoTabsEnum) => React.ReactNode
}

export const PlanoTabs = (props: PlanoTabsProps) => {
  const {
    tipoAtendimentoProfissional,
    isObservacaoAndAuxiliar = false,
    isFolhaRosto = false,
    isRetificacao = false,
    children,
  } = props

  const flags = useFlags()
  const { hasCboAuth } = useSession({ fetchPolicy: 'cache-only' })

  const { tabs, initialTab } = useMemo(
    () =>
      getPlanoTabsConfig(
        tipoAtendimentoProfissional,
        isObservacaoAndAuxiliar,
        isRetificacao,
        isFolhaRosto,
        flags,
        hasCboAuth
      ),
    [flags, hasCboAuth, isFolhaRosto, isObservacaoAndAuxiliar, isRetificacao, tipoAtendimentoProfissional]
  )

  const [currentPlanoTab, setCurrentPlanoTab] = useState(initialTab)

  return (
    <Grid>
      <Cell size={12}>
        <Tabs>
          {tabs.map((tab) =>
            tab.showItem ? (
              <CheckPermission {...tab.permissions}>
                <TabItem
                  active={currentPlanoTab === tab.enum}
                  onClick={() => setCurrentPlanoTab(tab.enum)}
                  data-testid={tab.testId}
                >
                  {tab.label}
                </TabItem>
              </CheckPermission>
            ) : null
          )}
        </Tabs>
      </Cell>
      <Cell size={12}>{children(currentPlanoTab)}</Cell>
    </Grid>
  )
}
